import Layout from "../include/layout";
import { Link, useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import { myroutes } from "../../routes/webroute";
import { checkAuthenticate } from "../app/providers/authSlice";
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";
import RolesService from "../roles/RolesService";
import HabilitationsService from "./HabilitationsService";
import Filarial from "../include/filarial";

//Creation du schema de validation des entrées
const schema = yup.object({
    roleId: yup.number().integer("Le role ne peut être null !").required("Ce champs est obligatoire !"),
}).required();

export default function HabilitationCreate() {
    const activeLink = "HABILITATIONS"

    const [roleId, setRoleId] = useState('')
    const [created, setCreated] = useState(false)
    const [readed, setReaded] = useState(false)
    const [updated, setUpdated] = useState(false)
    const [deleted, setDeleted] = useState(false)
    const [moved, setMoved] = useState(false)
    const [roles, setRoles] = useState([])

    const token = useSelector(state => state.auth.token)
    const navigate = useNavigate()

    //check if user is authenticated
    const dispatch = useDispatch();
    const isAuthenticated = useSelector(state => state.auth.isAuthenticate)

    //const for validation form
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm({
        //Fait appel au schema créer prédemment
        resolver: yupResolver(schema)
    })

    ///Save form data
    const handleSubmitHabilitation = async (event) => {
        //event.preventDefault()
        let form = {
            created, updated, moved, deleted, readed
        }

       await HabilitationsService.store(form, token).then((response) => {
            //console.log(response.data.data)
            if (response.data.status === 200) {
                //redirection sur index
                navigate(myroutes.habilitations_index)
                Swal.fire({
                    icon: "success",
                    text: response.data.message
                })
            } else {
                Swal.fire({
                    icon: "error",
                    text: response.data.message,
                    showConfirmButton: true,
                    timer: 3000
                })
                //setValidationError(response.data.erreur)
            }
        }).catch(error => {
            Swal.fire({
                icon: "error",
                text: error.message
            })
            //affichage des erreurs sur le formulaire
            //setValidationError(error.message)
        });
    }

    //get liste des roles
    const fetchRoles = async () => {
        await RolesService.index(token).then((res) => {
            //console.log(res.data.data)
            setRoles(res.data.data.roles)
        }).catch(error => {
            console.log(error)
        })
    }

    useEffect(() => {
        // Vérifier si l'utilisateur est connecté lors du chargement de l'application
        dispatch(checkAuthenticate());
        if (!isAuthenticated) {
            //console.log(isAuthenticated)
            //Redirection sur le dashboard
            navigate(myroutes.login)
        }
        fetchRoles()

    }, [dispatch]);

    return (
        <Layout>
            <div className="container-xxl flex-grow-1 container-p-y">
            <Filarial activeLink={activeLink} />

                <div className="row mb-4 mt-3">
                    {/* Bootstrap Validation */}
                    <div className="col-md">
                        <div className="card shadow-lg">
                            <h5 className="card-header">Enregistrement </h5>
                            <div className="card-body">
                                <Form className="needs-validation" noValidate onSubmit={handleSubmit(handleSubmitHabilitation)}>
                                    <div className="mb-3">
                                        <Form.Label className="form-label" htmlFor="bs-validation-name">Rôles <i className="text-danger">*</i></Form.Label>
                                        <Form.Select className="select2 form-select form-select-md" {...register("roleId")} id="select2Basic" value={roleId} onChange={(e) => setRoleId(e.target.value)} required>
                                            <option value="" selected disabled>-- Selectionnez un rôle --</option>
                                            {roles.map(item => (
                                                <option key={item.id} value={item.id}>{item.libelleRole}</option>
                                            ))}
                                        </Form.Select>
                                        <div className="text-danger">{errors.roleId?.message}</div>
                                    </div>
                                    <div className="mb-3">
                                        <Form.Label className="form-label" htmlFor="bs-validation-bio">Habilitations <i className="text-danger"></i></Form.Label> <br />
                                        <hr className="m-0" />
                                        <div className="form-check form-check-inline mt-3">
                                            <input className="form-check-input" type="checkbox" id="inlineCheckbox1" value={readed} onChange={(e) => setReaded(e.target.checked)} />
                                            <label className="form-check-label" htmlFor="inlineCheckbox1">Lire</label>
                                        </div>
                                        <div className="form-check form-check-inline mt-3">
                                            <input className="form-check-input" type="checkbox" id="inlineCheckbox1" value={created} onChange={(e) => setCreated(e.target.checked)} />
                                            <label className="form-check-label" htmlFor="inlineCheckbox1">Ajouter</label>
                                        </div>
                                        <div className="form-check form-check-inline">
                                            <input className="form-check-input" type="checkbox" id="inlineCheckbox2" value={updated} onChange={(e) => setUpdated(e.target.checked)} />
                                            <label className="form-check-label" htmlFor="inlineCheckbox2">Modifier</label>
                                        </div>
                                        <div className="form-check form-check-inline">
                                            <input className="form-check-input" type="checkbox" id="inlineCheckbox2" value={moved} onChange={(e) => setMoved(e.target.checked)} />
                                            <label className="form-check-label" htmlFor="inlineCheckbox2">Déplacer</label>
                                        </div>
                                        <div className="form-check form-check-inline">
                                            <input className="form-check-input" type="checkbox" id="inlineCheckbox2" value={deleted} onChange={(e) => setDeleted(e.target.checked)} />
                                            <label className="form-check-label" htmlFor="inlineCheckbox2">Supprimer</label>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-12">
                                            <button type="submit" className="btn btn-primary">Enregistrer</button>
                                        </div>
                                    </div>
                                </Form>


                            </div>
                        </div>
                    </div>
                    {/* /Bootstrap Validation */}
                </div>

            </div>

        </Layout>
    )
}